import { h } from 'hyperapp'

const Group = ({ group: { title, expressions }, click }) => (
    <div class="builder-group">
        <h2>{title}</h2>
        <div class="builder-expressions">
            {Object.keys(expressions).map((expression) => (
                <button type="button" class="builder-button" onclick={() => click(expression)} aria-label={expressions[expression]}>
                    {expression}
                </button>
            ))}
        </div>
    </div>
)

export default Group



// WEBPACK FOOTER //
// ./src/scripts/components/partials/group.js